// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { priceStyles } from "@steiner/Overrides/Widgets/ProductDetails/ProductDetailsPrice";
import { fontConfig } from "@steiner/XDL/PreStyle/typography";
import { css } from "styled-components";

priceStyles.productPrice = {
    wrapper: {
        css: css`
            margin-bottom: 12px;
            align-items: flex-start;
        `,
    },
    price: {
        priceText: {
            size: 26,
            lineHeight: "32px",
            weight: fontConfig.weight.bold,
        },
        unitOfMeasureText: { size: 26 },
        priceTextLabel: {
            color: "text.main",
            size: 16,
            lineHeight: "26px",
            weight: fontConfig.weight.semiBold,
        },
    },
    savingsMessageText: {
        size: 14,
        lineHeight: "22px",
        italic: false,
        css: css`
            margin-left: 55px;
        `,
    },
};